(function() {
    'use strict';
    
a3_cabin_reports.filter('paxNames', paxNames);
    /**
    * @memberof CabinReports
    * @ngdoc filter
    * @name paxNames
    * @description 
    *  List pax names in list and return $sce html 
    * @ngInject
    */      
function paxNames($sce) {
    return function(input) {
       var html =   '"<div class=\'row\'><div class=\'col-sm-offset-6 col-sm-2\'><strong>C</strong></div><div class=\' col-sm-1\'><strong>Y</strong></div> </div>';
       
 html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> Passengers </strong>"
                            html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.Passengers : 0) + "</div>";
                            html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.Passengers : 0) + '</div></div>';

        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> PRM </strong>"
                    html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.PRM : 0) + "</div>";
                    html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.PRM : 0) + '</div></div>';

        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> UMNR </strong>"
                    html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.UMNR : 0) + "</div>";
                    html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.UMNR : 0) + '</div></div>';

        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> DEP </strong>"
                    html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.DEP : 0) + "</div>";
                    html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.DEP : 0) + '</div></div>\"';
        
       
       return $sce.trustAsHtml(html);
   }
};

})();